import type { BadgeTone } from "../../components/ui/badge";

export type CallbackClassification = "needs_callback" | "not_picked" | "voicemail" | "rescheduled";
export type CallbackStatus =
  | "pending" | "scheduled" | "paused" | "completed" | "failed" | "cancelled" | "needs_schedule_details";

export type ClassificationFilter = CallbackClassification | "all";
export type StatusFilter = CallbackStatus | "all";

export interface Callback {
  id: string;
  contactId: string;
  contactName: string;
  phone: string;
  scheduleId: string;
  classification: CallbackClassification;
  status: CallbackStatus;
  callbackDate: string; // YYYY-MM-DD
  callbackTime: string; // HH:mm (24h)
  callbackType: string;
  callbackValue: string;
  timezone: string;
  aiSummary: string;
  scheduledForUtc?: string | null;
}

export const CLASSIFICATION_META: Record<CallbackClassification, { label: string; tone: BadgeTone }> = {
  needs_callback: { label: "Needs Callback", tone: "brand" },
  not_picked:     { label: "Not Picked", tone: "neutral" },
  voicemail:      { label: "Voicemail", tone: "warning" },
  rescheduled:    { label: "Rescheduled", tone: "violet" },
};

export const STATUS_META: Record<CallbackStatus, { label: string; tone: BadgeTone }> = {
  pending:                 { label: "Pending", tone: "neutral" },
  scheduled:               { label: "Scheduled", tone: "success" },
  paused:                  { label: "Paused", tone: "warning" },
  completed:               { label: "Completed", tone: "success" },
  failed:                  { label: "Failed", tone: "danger" },
  cancelled:               { label: "Cancelled", tone: "neutral" },
  needs_schedule_details:  { label: "Needs Schedule Details", tone: "warning" },
};

export const CLASSIFICATION_OPTIONS: ReadonlyArray<{ value: ClassificationFilter; label: string }> = [
  { value: "all", label: "All Classifications" },
  { value: "needs_callback", label: "Needs Callback" },
  { value: "not_picked", label: "Not Picked" },
  { value: "voicemail", label: "Voicemail" },
  { value: "rescheduled", label: "Rescheduled" },
];

export const STATUS_OPTIONS: ReadonlyArray<{ value: StatusFilter; label: string }> = [
  { value: "all", label: "All Statuses" },
  { value: "pending", label: "Pending" },
  { value: "scheduled", label: "Scheduled" },
  { value: "paused", label: "Paused" },
  { value: "completed", label: "Completed" },
  { value: "failed", label: "Failed" },
  { value: "cancelled", label: "Cancelled" },
  { value: "needs_schedule_details", label: "Needs Schedule Details" },
];
